import { useEffect, useMemo } from 'react';

import { useEstablecimientos } from '@/features/establecimientos/hooks/useEstablecimientos';

/**
 * Loads all establecimientos and returns a map from uid_establecimiento → nombre.
 * Used in the protocolos table to display establishment names given their UIDs.
 */
export function useEstablecimientosMap() {
  const { items, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useEstablecimientos({ limit: 100 });

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      void fetchNextPage();
    }
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  const map = useMemo(() => {
    const m = new Map<string, string>();
    for (const item of items) {
      m.set(item.uid_establecimiento, item.nombre);
    }
    return m;
  }, [items]);

  return {
    map,
    isLoading: isLoading || hasNextPage,
  };
}
